import { render, staticRenderFns } from "./Logoff.vue?vue&type=template&id=da3adbc8&"
import script from "./Logoff.vue?vue&type=script&lang=js&"
export * from "./Logoff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports